import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { DetailedGapDescription, EmpiricalConcept } from '../model/models'

export class EmpiricalConceptAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.getForIsDiversityDimensions = this.getForIsDiversityDimensions.bind(this)
  }

  public getForIsDiversityDimensions(): Promise<EmpiricalConcept[]> {
    const endpoint = `/empirical-concepts?is_diversity_dimension=True`
    return this.get<EmpiricalConcept[]>(endpoint)
      .then((response: AxiosResponse<EmpiricalConcept[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public getEmpiricalConceptsInfo(
    contextVariantId: number,
  ): Promise<Record<string, DetailedGapDescription>> {
    return this.get<Record<string, DetailedGapDescription>>(
      `gap-cause-descriptions/${contextVariantId}`,
    )
      .then((response: AxiosResponse<Record<string, DetailedGapDescription>>) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const empiricalConceptAPI = new EmpiricalConceptAPI(httpConfig)
